
import { createDeckWidgetQueue } from './script_request_queue';

var deckWidgetQueue = createDeckWidgetQueue();

function fetchScript(url, params, options) {
  if (options) {
    deckWidgetQueue.enqueue(url, params, options);
  } else {
    deckWidgetQueue.enqueue(url, params);
  }
}

function initializeTypePreference() {
  var preference = getCurrentTypePreference()
  showDeckContainerTab(preference);
}

var showDeckContainerTab = function(preference) {
  document.querySelectorAll('.type-switcher-tabs, .deck-action-menu, .deck-price-menu').forEach(function(container) {
    var selected = findPreferredTabTrigger(container, preference);
    if (selected) {
      bootstrap.Tab.getOrCreateInstance(selected).show();
    }
  });
}

function findPreferredTabTrigger(container, preference) {
  if (!container || !preference) return null;
  // Use indexOf rather than .match() — .match() compiles `preference` as a
  // regex, and the URL fragment can contain regex metacharacters (e.g. a
  // trailing backslash from a Facebook fbclid like #paper\) that would crash
  // here with "Invalid regular expression: /tab-paper\/".
  var needle = "tab-" + preference;
  var matches = Array.from(container.querySelectorAll('a[data-bs-toggle="tab"]')).filter(function(el) {
    var href = el.getAttribute("href");
    return href && href.indexOf(needle) !== -1;
  });
  return matches.find(function(el) { return !el.classList.contains('dropdown-item'); }) || matches[0] || null;
}

function deckDisplayParams(container) {
  if (!container) return {};
  return {
    deck_group: container.dataset.deckGroup || 'type',
    deck_sort: container.dataset.deckSort || 'mana_value',
    deck_sort_direction: container.dataset.deckSortDirection || 'auto',
    deck_view: container.dataset.deckView || 'text',
  };
}

function deckStatsDisplayParams(container) {
  var params = deckDisplayParams(container);
  delete params.deck_view;
  return params;
}

function initializeDeckComponents(tabId, deckId, deckString, viewModeOverride, allowEmptyDeck, deckFormat, companion, commander, commanderAlt, showDeckWarnings) {
  if (typeof commander === 'boolean' && commanderAlt === undefined && showDeckWarnings === undefined) {
    showDeckWarnings = commander;
    commander = undefined;
    commanderAlt = undefined;
  }
  var deckStringIfNoDeckId = (deckId == null || deckId =="") ? deckString : "";
  var useUnsavedDeckPost = (deckId == null || deckId === "") && deckStringIfNoDeckId != null && deckStringIfNoDeckId !== "";
  var hasDeckSource = (deckId != null && deckId !== "") || (deckStringIfNoDeckId != null && deckStringIfNoDeckId !== "") || allowEmptyDeck === true;
  var container = document.getElementById(tabId);
  var showDeckWarningsParam = showDeckWarnings === true;
  var lazyPaneRequestOptions = useUnsavedDeckPost ? { method: 'POST' } : undefined;

  function requestBaseParams(tab, hash) {
    return Object.assign({
      type: tab.dataset.type,
      id: deckId,
      deck: deckStringIfNoDeckId,
      deck_format: deckFormat,
      companion: companion,
      commander: commander,
      commander_alt: commanderAlt,
      selector: hash,
      view_mode_override: viewModeOverride,
      show_deck_warnings: showDeckWarningsParam,
    }, deckDisplayParams(container));
  }

  function loadPane(tab, hash) {
    if (!hasDeckSource) return;
    if (!tab) return;
    if (tab.dataset.myPrice && !tab.dataset.loaded) {
      fetchScript('/deck/my_price_js', requestBaseParams(tab, hash), lazyPaneRequestOptions);
    } else if (tab.dataset.deckComponent && !tab.dataset.loaded) {
      fetchScript('/deck/component', requestBaseParams(tab, hash), lazyPaneRequestOptions);
    } else if (tab.dataset.deckStats && !tab.dataset.loaded) {
      fetchScript('/deck/stats', Object.assign({
        id: deckId,
        type: tab.dataset.type,
        deck: deckStringIfNoDeckId,
        deck_format: deckFormat,
        companion: companion,
        commander: commander,
        commander_alt: commanderAlt,
        selector: hash,
        view_mode_override: viewModeOverride,
      }, deckStatsDisplayParams(container)), lazyPaneRequestOptions);
    }
  }

  function loadTab(tabEl) {
    if (!container || !container.contains(tabEl)) return;
    if (!tabEl.matches('[data-bs-toggle="tab"]')) return;
    var hash = tabEl.getAttribute('href') || tabEl.dataset.bsTarget;
    // Use getElementById so numeric IDs (e.g. "413-tab-paper") work — those
    // start with a digit and are invalid as CSS selectors for querySelector.
    var tabId2 = hash && hash.charAt(0) === '#' ? hash.slice(1) : hash;
    var tab = tabId2 ? document.getElementById(tabId2) : null;
    loadPane(tab, hash);
  }

  function activeDeckPane() {
    if (!container) return null;
    return container.querySelector('.tab-pane.active[data-deck-component="true"], .tab-pane.active[data-my-price="true"]');
  }

  function reloadActiveDeckPane() {
    var tab = activeDeckPane();
    if (!tab) return;
    tab.innerHTML = "<p class='text-center text-muted'>Loading ...</p>";
    loadPane(tab, '#' + tab.id);
  }

  function resetDeckPanes() {
    if (!container) return;
    container.querySelectorAll('.tab-pane[data-deck-component="true"], .tab-pane[data-my-price="true"]').forEach(function(tab) {
      delete tab.dataset.loaded;
    });
  }

  document.addEventListener('shown.bs.tab', function(e) {
    loadTab(e.target);
  });

  var initialPreference = getCurrentTypePreference();
  var initialTab = findPreferredTabTrigger(container, initialPreference);
  if (!initialTab) {
    initialTab = document.querySelector('#' + CSS.escape(tabId) + ' a.nav-link.active[data-bs-toggle="tab"]');
  }
  if (initialTab) {
    loadTab(initialTab);
  } else {
    var initialPane = activeDeckPane();
    if (initialPane) loadPane(initialPane, '#' + initialPane.id);
  }

  if (container) {
    container.addEventListener('change', function(e) {
      var control = e.target && e.target.closest('.deck-display-control-select');
      if (!control) return;

      var groupControl = container.querySelector('.deck-display-group');
      var sortControl = container.querySelector('.deck-display-sort');
      var directionControl = container.querySelector('.deck-display-direction');
      var viewControl = container.querySelector('.deck-display-view');
      if (groupControl) container.dataset.deckGroup = groupControl.value;
      if (sortControl) container.dataset.deckSort = sortControl.value;
      if (directionControl) container.dataset.deckSortDirection = directionControl.value;
      if (viewControl) container.dataset.deckView = viewControl.value;
      resetDeckPanes();
      reloadActiveDeckPane();
    });

    container.addEventListener('click', function(e) {
      var toggle = e.target && e.target.closest('.deck-view-options-toggle');
      if (!toggle) return;
      var shell = container.querySelector('.deck-display-controls-shell');
      if (!shell) return;
      var open = !shell.classList.contains('is-open');
      shell.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
}


var getCurrentTypePreference = function() {
  var url = document.location.toString();
  if (url.match('#')) {
    return url.split('#')[1];
  } else {
    var preference = Cookies.get('type-preference');
    if (preference == "online") {
    } else if (preference == "arena") {
    } else {
      preference = "paper";
    }
    return preference;
  }
}
window.getCurrentTypePreference = getCurrentTypePreference

function splitDecklistsIntoTwoColumns() {
  // only do for firefox and desktop
  if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 && window.matchMedia("screen and (min-width: 900px)").matches) {
    document.querySelectorAll(".deck-table-container").forEach(function(container) {
      if (!container.classList.contains("deck-table-container-text")) return;
      var tables = container.querySelectorAll(".deck-view-deck-table");
      if (tables.length !== 1) return;
      var table = tables[0];
      var secondTable = table.cloneNode(false);
      var rows = table.querySelectorAll("tr");
      var rowCount = Math.round(rows.length * 0.5);
      var tbody = document.createElement('tbody');
      secondTable.appendChild(tbody);
      Array.from(rows).slice(rowCount).forEach(function(row) {
        tbody.appendChild(row);
      });
      table.parentNode.appendChild(secondTable);
    });
  }
}

function canUseDeckVisualStackHover() {
  return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}

function deckVisualStackForTarget(target) {
  if (!target || !target.closest) return null;
  return target.closest('.deck-visual-container-stacks .deck-visual-category-stack, .deck-visual-container-copy_stacks .deck-visual-category-stack');
}

function resetDeckVisualStackHover(stack) {
  if (!stack) return;
  stack.style.removeProperty('--deck-visual-stack-hover-extra');
  stack.querySelectorAll('.deck-visual-card').forEach(function(card) {
    card.style.removeProperty('--deck-stack-hover-y');
    card.classList.remove('is-stack-hovered');
  });
}

function pointerRemainsInsideStack(stack, event) {
  if (!event || typeof document.elementFromPoint !== 'function') return false;
  var target = document.elementFromPoint(event.clientX, event.clientY);
  return !!(target && stack.contains(target));
}

function pointerWithinStackRect(stack, event) {
  if (!stack || !event) return false;
  var rect = stack.getBoundingClientRect();
  return event.clientX >= rect.left &&
    event.clientX <= rect.right &&
    event.clientY >= rect.top &&
    event.clientY <= rect.bottom;
}

var activeDeckVisualStack = null;

function deckVisualCardAtPoint(stack, event) {
  if (!stack || !event) return null;

  if (typeof document.elementFromPoint === 'function') {
    var target = document.elementFromPoint(event.clientX, event.clientY);
    var targetCard = target && target.closest && target.closest('.deck-visual-card');
    if (targetCard && stack.contains(targetCard)) return targetCard;
  }

  return Array.from(stack.querySelectorAll('.deck-visual-card')).find(function(card) {
    var rect = card.getBoundingClientRect();
    return event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;
  }) || null;
}

function applyDeckVisualStackHover(card, stack) {
  if (!card || !stack || !canUseDeckVisualStackHover()) return;

  var cards = Array.from(stack.querySelectorAll('.deck-visual-card'));
  var hoverIndex = cards.indexOf(card);
  if (hoverIndex < 0) return;

  var stackStyle = window.getComputedStyle(stack);
  var offset = parseFloat(stackStyle.getPropertyValue('--deck-visual-stack-offset')) || 44;
  var cardStack = card.querySelector('.deck-visual-card-stack') || card;
  var cardHeight = Math.max(card.getBoundingClientRect().height, cardStack.getBoundingClientRect().height);
  var expansion = Math.max(cardHeight - offset, 0);
  var effectiveExpansion = hoverIndex === cards.length - 1 ? 0 : expansion;

  activeDeckVisualStack = stack;
  stack.style.setProperty('--deck-visual-stack-hover-extra', effectiveExpansion + 'px');
  cards.forEach(function(stackCard, index) {
    var baseY = index * offset;
    var y = baseY + (index > hoverIndex ? effectiveExpansion : 0);
    stackCard.style.setProperty('--deck-stack-hover-y', y + 'px');
    stackCard.classList.toggle('is-stack-hovered', index === hoverIndex);
  });
}

function initializeDeckVisualStackHover() {
  document.addEventListener('mouseover', function(e) {
    var stack = deckVisualStackForTarget(e.target);
    if (!stack) return;
    var card = deckVisualCardAtPoint(stack, e) || (e.target.closest && e.target.closest('.deck-visual-card'));
    if (!card || !stack.contains(card)) return;
    applyDeckVisualStackHover(card, stack);
  });

  document.addEventListener('mousemove', function(e) {
    if (activeDeckVisualStack && !pointerWithinStackRect(activeDeckVisualStack, e)) {
      resetDeckVisualStackHover(activeDeckVisualStack);
      activeDeckVisualStack = null;
      return;
    }

    var stack = deckVisualStackForTarget(e.target) || (activeDeckVisualStack && pointerWithinStackRect(activeDeckVisualStack, e) ? activeDeckVisualStack : null);
    if (!stack) return;
    var card = deckVisualCardAtPoint(stack, e) || (e.target.closest && e.target.closest('.deck-visual-card'));
    if (!card || !stack.contains(card)) return;
    applyDeckVisualStackHover(card, stack);
  });

  document.addEventListener('mouseout', function(e) {
    var stack = activeDeckVisualStack || deckVisualStackForTarget(e.target);
    if (!stack || pointerWithinStackRect(stack, e)) return;
    if (e.relatedTarget && stack.contains(e.relatedTarget)) return;
    window.setTimeout(function() {
      if (pointerRemainsInsideStack(stack, e) || pointerWithinStackRect(stack, e)) return;
      resetDeckVisualStackHover(stack);
      if (activeDeckVisualStack === stack) activeDeckVisualStack = null;
    }, 0);
  });

  document.addEventListener('focusin', function(e) {
    var stack = deckVisualStackForTarget(e.target);
    if (!stack) return;
    var card = e.target.closest && e.target.closest('.deck-visual-card');
    if (!card || !stack.contains(card)) return;
    applyDeckVisualStackHover(card, stack);
  });

  document.addEventListener('focusout', function(e) {
    var stack = deckVisualStackForTarget(e.target);
    if (!stack) return;
    if (e.relatedTarget && stack.contains(e.relatedTarget)) return;
    resetDeckVisualStackHover(stack);
    if (activeDeckVisualStack === stack) activeDeckVisualStack = null;
  });
}

function setDeckVisualCardFace(card, showBack) {
  if (!card) return;

  var dfcCards = card.querySelectorAll('.deck-visual-card-dfc');
  if (!dfcCards.length) return;

  dfcCards.forEach(function(dfcCard) {
    dfcCard.classList.toggle('active', showBack);
  });
  card.classList.toggle('is-dfc-back', showBack);

  var toggle = card.querySelector('.deck-visual-dfc-toggle');
  if (toggle) {
    toggle.setAttribute('aria-pressed', showBack ? 'true' : 'false');
    toggle.setAttribute('aria-label', showBack ? 'Show front face' : 'Flip card face');
  }
}

function eventIsInsideElement(event, element) {
  if (!event || !element || typeof element.getBoundingClientRect !== 'function') return false;

  var rect = element.getBoundingClientRect();
  return event.clientX >= rect.left &&
    event.clientX <= rect.right &&
    event.clientY >= rect.top &&
    event.clientY <= rect.bottom;
}

function initializeDeckVisualDfcToggle() {
  document.addEventListener('click', function(e) {
    var toggle = Array.from(document.querySelectorAll('.deck-visual-card[data-card-image-back] .deck-visual-dfc-toggle')).find(function(button) {
      return eventIsInsideElement(e, button);
    });
    if (!eventIsInsideElement(e, toggle)) return;

    var card = toggle.closest('.deck-visual-card[data-card-image-back]');
    if (!card) return;

    e.preventDefault();
    e.stopPropagation();
    setDeckVisualCardFace(card, !card.classList.contains('is-dfc-back'));
  }, true);

  document.addEventListener('click', function(e) {
    var toggle = e.target && e.target.closest('.deck-visual-dfc-toggle');
    if (!toggle) return;

    e.preventDefault();
    e.stopPropagation();

    var card = toggle.closest('.deck-visual-card');
    if (!card) return;
    setDeckVisualCardFace(card, !card.classList.contains('is-dfc-back'));
  });
}

function initializeDeckVisualDesktopDfcCardLinks() {
  document.addEventListener('click', function(e) {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (e.target && e.target.closest('.deck-visual-dfc-toggle')) return;

    var card = e.target && e.target.closest('.deck-visual-card[data-card-image-back]');
    if (!card || !card.dataset.cardUrl) return;

    window.location.href = card.dataset.cardUrl;
  });
}

window.MTGGoldfish = MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() {
  splitDecklistsIntoTwoColumns();
  initializeDeckVisualStackHover();
  initializeDeckVisualDfcToggle();
  initializeDeckVisualDesktopDfcCardLinks();

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.matches('.decklist-more')) return;
    e.target.style.display = 'none';
    var more = e.target.closest(".decklist-more-container");
    if (more) {
      var purchase = more.querySelector(".decklist-purchase-more");
      if (purchase) purchase.style.display = '';
    }
  });

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.matches('.deck-tools-btn-download-submit')) return;
    e.preventDefault();
    var form = e.target.closest('form');
    if (!form) return;
    var outputField = form.querySelector(".field-output");
    var typeField = form.querySelector(".field-type");
    if (outputField) outputField.value = e.target.dataset.output;
    if (typeField) typeField.value = e.target.dataset.type;
    form.submit();
  });

  document.querySelectorAll(".copy-paste-box").forEach(function(el) {
    el.style.height = el.scrollHeight + "px";
    el.addEventListener('click', function() { el.select(); });
  });

  document.querySelectorAll(".auto-select-text").forEach(function(el) {
    el.addEventListener('click', function() { el.select(); });
  });

  document.querySelectorAll(".my-decks-btn-add").forEach(function(el) {
    el.addEventListener('click', function(e) {
      var target = el.dataset.target;
      var textarea = document.getElementById(target);
      var card = document.querySelector('.add-card-' + target);
      var qty = document.querySelector('.add-qty-' + target);
      if (textarea && card && qty) {
        textarea.value = textarea.value + "\n" + qty.value + " " + card.value;
      }
    });
  });

  function showDecksTab(panelName) {
    var filterPanel = document.getElementById("search-filter-panel");
    if (filterPanel) filterPanel.value = panelName;

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const params = new URLSearchParams({ panel: panelName });
    const url = `/decks?${params.toString()}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': csrfToken
      },
      credentials: 'same-origin'
    })
    .then(response => {
      if (!response.ok) throw new Error("Turbo Stream request failed");
      return response.text();
    })
    .then(html => {
      Turbo.renderStreamMessage(html);
    })
    .catch(error => {
      console.error(error);
    });
  }

  document.addEventListener('shown.bs.tab', function(e) {
    var tabEl = e.target;
    var container = document.getElementById('mydecks-tabs');
    if (!container || !container.contains(tabEl)) return;
    if (!tabEl.matches('[data-bs-toggle="tab"]')) return;
    var hash = tabEl.getAttribute('href') || tabEl.dataset.bsTarget;
    if (hash !== "#tab-search") {
      showDecksTab(hash);
    }
    var relatedHash = e.relatedTarget && (e.relatedTarget.getAttribute('href') || e.relatedTarget.dataset.bsTarget);
    if (relatedHash) {
      var relatedPaneId = relatedHash.charAt(0) === '#' ? relatedHash.slice(1) : relatedHash;
      var relatedTab = document.getElementById(relatedPaneId);
      if (relatedTab) {
        if (hash === "#tab-search") {
          relatedTab.innerHTML = "<p class='empty'>Search Results have expired. Please search again.</p>";
        } else {
          relatedTab.innerHTML = "<p class='empty'>Loading ...</p>";
        }
      }
    }
  });

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest('.hidden-form-submit')) return;
    var submitEl = e.target.closest('.hidden-form-submit');
    var hiddenForm = submitEl.querySelector(".hidden-form");
    if (!hiddenForm) return;
    var f = document.createElement('form');
    f.target = '_blank';
    f.method = 'POST';
    f.style.display = 'none';
    f.action = hiddenForm.dataset.url;
    hiddenForm.querySelectorAll(".hidden-form-input").forEach(function(inp) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = inp.dataset.name;
      input.value = inp.dataset.value;
      f.appendChild(input);
    });
    document.body.appendChild(f);
    f.submit();
    document.body.removeChild(f);
  });

});

window.initializeDeckComponents = initializeDeckComponents;
window.splitDecklistsIntoTwoColumns = splitDecklistsIntoTwoColumns;
window.initializeTypePreference = initializeTypePreference;
